export const PROTECTED_VALUES_PARAMETER = 'protected-values';
